const bufferToHex = (buffer: ArrayBuffer | Uint8Array) =>
  Array.from(new Uint8Array(buffer))
    .map((x) => x.toString(16).padStart(2, '0'))
    .join('');

export async function generateSecureOtpPayload(mobile: string, partnerId: string) {
  const secretKey = process.env.REACT_APP_OTP_SECRET_KEY as string;

  let fingerprint = localStorage.getItem('app_device_id');
  if (!fingerprint) {
    fingerprint = crypto.randomUUID();
    localStorage.setItem('app_device_id', fingerprint);
  }

  const payloadData = { mobile, partnerId, fingerprint, timestamp: Date.now() };
  const encoder = new TextEncoder();
  const dataToEncrypt = encoder.encode(JSON.stringify(payloadData));

  const keyMaterial = await crypto.subtle.importKey(
    'raw',
    encoder.encode(secretKey),
    { name: 'AES-CBC' },
    false,
    ['encrypt']
  );

  const iv = crypto.getRandomValues(new Uint8Array(16));
  const encryptedBuffer = await crypto.subtle.encrypt({ name: 'AES-CBC', iv }, keyMaterial, dataToEncrypt);

  return `${bufferToHex(iv)}:${bufferToHex(encryptedBuffer)}`;
}